import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import { getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import Placeholder from '../Placeholder';
export var ThumbWithLoader = function (_a) {
    var deviation = _a.deviation, isLoading = _a.isLoading, className = _a.className, width = _a.width, height = _a.height, greenLikeCrop = _a.greenLikeCrop;
    var t = useTranslation().t;
    if (!deviation || isLoading) {
        return React.createElement(Placeholder, { className: className, width: width, height: height });
    }
    return (React.createElement(DeviationLink, { deviation: deviation, key: deviation.deviationId, className: className, title: getTranslatedDeviationTitle(deviation, t) },
        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, greenLikeCrop: greenLikeCrop })));
};
ThumbWithLoader.displayName = 'ThumbWithLoader';
export default ThumbWithLoader;
//# sourceMappingURL=ThumbWithLoader.js.map